"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISerializedCharacteristicProvenanceSchema = exports.ISerializedProvenanceNodeSchema = exports.ISerializedRelativeResolutionSchema = exports.ISerializedValueContributionSchema = void 0;
const zod_1 = require("zod");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
const SignalId_1 = require("../DesignModels/SignalId");
const nanSafeNumber = zod_1.default
    .union([zod_1.default.number(), zod_1.default.nan(), zod_1.default.null()])
    .optional()
    .nullish()
    .transform((v) => (v === null || v === undefined || Number.isNaN(v) ? undefined : v));
exports.ISerializedValueContributionSchema = zod_1.default.object({
    value: nanSafeNumber,
    allowableRange: zod_1.default
        .object({
        min: nanSafeNumber,
        max: nanSafeNumber,
    })
        .optional(),
});
exports.ISerializedRelativeResolutionSchema = zod_1.default.lazy(() => zod_1.default.object({
    net: zod_1.default.string(),
    characteristic: BoundaryCharacteristic_1.BoundaryCharacteristicSchema,
    resolvedValue: exports.ISerializedValueContributionSchema.optional(),
    provenance: zod_1.default.array(exports.ISerializedProvenanceNodeSchema).optional(),
}));
exports.ISerializedProvenanceNodeSchema = zod_1.default.lazy(() => zod_1.default.object({
    boundaryId: zod_1.default.string(),
    fullModuleName: zod_1.default.string(),
    signalId: SignalId_1.SignalIdSchema.optional(),
    contributed: exports.ISerializedValueContributionSchema,
    relativeTo: exports.ISerializedRelativeResolutionSchema.optional(),
}));
exports.ISerializedCharacteristicProvenanceSchema = zod_1.default.lazy(() => zod_1.default.object({
    contributions: zod_1.default.array(exports.ISerializedProvenanceNodeSchema).optional(),
    limitingFactor: zod_1.default
        .object({
        min: zod_1.default.union([exports.ISerializedProvenanceNodeSchema, zod_1.default.array(exports.ISerializedProvenanceNodeSchema)]).optional(),
        max: zod_1.default.union([exports.ISerializedProvenanceNodeSchema, zod_1.default.array(exports.ISerializedProvenanceNodeSchema)]).optional(),
    })
        .optional(),
}));
//# sourceMappingURL=ISerializedProvenanceNode.js.map